import * as CryptoJS from 'crypto-js';

const KEY_SEPARATOR = '|';
export const MSAL_STORAGE_KEY_PREFIX = 'msal.';

export type LocalStorageEncryptionKey = string;

/** Values passed to patched localStorage.setItem (runtime may pass numbers before coercion). */
export type LocalStorageWritableValue =
  | string
  | number
  | boolean
  | null
  | undefined;

export function buildLocalStorageKeyMaterial(
  homeAccountId: string,
  localAccountId: string,
  clientId: string
): string {
  return `${homeAccountId}${KEY_SEPARATOR}${localAccountId}${KEY_SEPARATOR}${clientId}`;
}

export function deriveLocalStorageEncryptionKey(
  keyMaterial: string
): LocalStorageEncryptionKey {
  return CryptoJS.SHA256(keyMaterial).toString(CryptoJS.enc.Hex);
}

export function hashLocalStorageKeyName(
  plainKey: string,
  encryptionKey: LocalStorageEncryptionKey
): string {
  return CryptoJS.HmacSHA256(plainKey, encryptionKey).toString(CryptoJS.enc.Hex);
}

export function normalizeLocalStorageValue(value: LocalStorageWritableValue): string {
  return String(value);
}

export function encryptLocalStorageValue(
  plainText: LocalStorageWritableValue,
  encryptionKey: LocalStorageEncryptionKey
): string {
  const text = normalizeLocalStorageValue(plainText);
  return CryptoJS.AES.encrypt(text, encryptionKey).toString();
}

export function decryptLocalStorageValue(
  cipherText: string,
  encryptionKey: LocalStorageEncryptionKey
): string | null {
  const bytes = CryptoJS.AES.decrypt(cipherText, encryptionKey);
  const plain = bytes.toString(CryptoJS.enc.Utf8);
  return plain || null;
}

export function isMsalStorageKey(key: string): boolean {
  return key.startsWith(MSAL_STORAGE_KEY_PREFIX);
}

const HASHED_STORAGE_KEY_PATTERN = /^[a-f0-9]{64}$/i;

export function isHashedStorageKeyName(key: string): boolean {
  return HASHED_STORAGE_KEY_PATTERN.test(key);
}

const ENCRYPTED_VALUE_PREFIX = 'U2FsdGVkX1';

export function isEncryptedStorageValue(value: string): boolean {
  return value.startsWith(ENCRYPTED_VALUE_PREFIX);
}
